import React, { useMemo, useState, useEffect } from 'react'
import { FaBook, FaThumbsUp, FaThumbsDown, FaRegIdCard, FaBuilding, FaAddressCard } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, TextFieldIcon, SelectFieldIcon } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { Formik } from 'formik'
import { Bar } from 'react-chartjs-2';
import { values } from 'lodash'

const steps = [
  "Pending", "Actioned"
]

const ActionField = ( record ) => {
    return (

        <div onClick={async () => {
            await localStorage.setItem( "link", "client_audit_feedback" )
            await localStorage.setItem( "applicationId", record.value )
            return window.location.reload()
        } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
            {`View`}
        </div>
    )
}


export default function AllAuditReports( ) {
    const [ applicationsDropdown, setApplicationsDropdown ] = useState( [] )
    const [ services, setServices ] = useState( [''] )

    const auditReportColumns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Email",
        accessor: "email_address"
        },
        {
        Header: "Name",
        accessor: "name"
        },
        {
        Header: "Auditor",
        accessor: "auditor"
        },
        {
        Header: "Audit Date",
        accessor: "audit_date"
        },
        {
        Header: "Created at",
        accessor: "created_at"
        },
        {
        Header: "Action",
        accessor: "id",
        Cell: ActionField
        }
    ])
    
    const [ auditReportRecords, setAuditReportRecords ] = useState( [] )
    const [ records, setRecords ] = useState( [] )
    const [ loading, setLoading ] = useState( true )

    React.useEffect( () => {
        if( loading ) {
            fetchApplications()
        }
    },[ loading ])

    const fetchApplications = async () => {
        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
            if( response.data ) {
                const results = response.data.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        stage: result.stage,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        email_address: result.created_by,
                        date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } ).filter( record => { 
                    return record.status?.toUpperCase() !== "APPROVED"
                } )

                //update the state
                setRecords( results )
                setLoading( false )

                let dbApps = response.data.map((item) => {
                    return {
                      id: item.id,
                      label: `${item.trading_name+ ": (" +item.created_by+ ")"}`,
                      value: item.created_by
                    }
                });
                setApplicationsDropdown(dbApps)
            }
        } catch (error) {
            alert( "Server error occurred." )
            setLoading( false )
        }
    }

    const handleAuditReportsSearch = async (values) => {

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/search_audit_reports`, {
                from_date: values.from_date,
                to_date: values.to_date,
                application_id: values.application_id
            })
            //console.log("application id ==> "+values.application_id)
    
            if( response.data.success === true ) {
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        name: result.trading_name,
                        email_address: result.applicant,
                        audit_date: result.audit_date,
                        auditor: result.created_by,
                        created_at: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.application_id
                    }
                } )
                //console.log(response.data)
                //console.log("search is done")

                //update the state
                setAuditReportRecords( results )
                setLoading( false )
            }
        } catch (error) {}
    }

    if( localStorage.getItem( "link" ) === "all_audit_reports" ) {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`Audit Reports`}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">
                            <Formik initialValues={{
                                from_date: values.from_date,
                                to_date: values.to_date,

                                }} onSubmit={handleAuditReportsSearch}>
                                { ( { handleSubmit, handleBlur, handleChange, values } ) => {
                                        return (
                                            <form className="my-2 bg-white" onSubmit={handleSubmit}>
                                                <div className="flex row px-5">
                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="from_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.from_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="From"
                                                            required={true}
                                                            disabled={false}
                                                            question="From" 
                                                        />
                                                    </div>

                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="to_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.to_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="To"
                                                            required={true}
                                                            disabled={false}
                                                            question="To" 
                                                        />
                                                    </div>

                                                    <div className="basis-1/4 pt-2">
                                                        <SelectFieldIcon 
                                                            name="application_id"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.application_id}
                                                            iconComponent={<FaBuilding color={`#AFC836`} />} 
                                                            label="Search Application"
                                                            required={false}
                                                            disabled={false}
                                                            options={applicationsDropdown.map( ( { id, label, value } ) => {
                                                                return { id, label, value }
                                                            } )}
                                                            question="Search Application" 
                                                        />
                                                    </div>

                                                    <div className="basis-1/4">
                                                        <div className="w-full pt-8 grid grid-cols-1">
                                                            <button className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="submit" name="submit">Submit</button>
                                                        </div>
                                                    </div>                                                    
                                                </div>
                                            </form>
                                        )
                                    }  }
                            </Formik>
                        
                            <Table 
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="My Reports"
                            columns={auditReportColumns}
                            data={auditReportRecords}
                            hidePagination={false}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }

    if( localStorage.getItem( "link" ) === "per_district_apps_report" ) {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`Application Per Districts Report`}
                        </div>

                        <div className="flex items-center justify-between my-5">
                            <div className="flex items-center justify-between px-5 py-2 text-sm bg-white w-full h-44">
                                {/* <Bar data={per_district_numbers} options={per_district_options} /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }
}